<div class="container mt-4">
    <div class="row">
        <div class="col-12 col-lg-8 offset-lg-2">
            <div class="bg-body-secondary rounded-3 p-3">
                @let headerImage = company()?.headerImage || 'assets/images/surefire-logo.svg';

                <div class="text-center">
                    <img class="mb-4" [src]="headerImage" alt="Surefire Logo" class="img-fluid" />
                </div>

                <div class="row my-4">
                    <div class="order-2 order-md-1 col-md-6 mt-3 text-center text-md-start">
                        @if (error()) {
                            <h1 class="text-danger">Sorry!</h1>
                            <p class="fw-bold">There has been a problem completing this request.</p>
                            <p>Please contact us directly for further assistance.</p>
                        } @else {
                            @if (company(); as companyDetails) {
                                <h1 class="text-success">Payment Success!</h1>
                                <p>Hi {{ customer()?.prettyName }},</p>
                                <p class="fw-bold">Your payment has been received.</p>
                                <p>Thank you on behalf of {{ companyDetails.name }}.</p>
                            }
                        }
                    </div>
                    <div class="order-1 order-md-2 col-md-6 text-center">
                        @if (error()) {
                            <fa-icon class="text-danger" size="10x" [icon]="['fas', 'xmark-circle']"></fa-icon>
                        } @else {
                            <fa-icon class="text-success" size="10x" [icon]="['fas', 'check-circle']"></fa-icon>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
